import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactifi/dist/es/components/Button';

export default class ConfirmationModal extends React.Component {

  static propTypes = {
    showModal: PropTypes.bool,
    title: PropTypes.string,
    id: PropTypes.string,
    message: PropTypes.string,
    closeText: PropTypes.string,
    confirmText: PropTypes.string,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      showModal: this.props.showModal
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.showModal !== state.showModal) {
      return {
        showModal: props.showModal
      };
    }
    return null;
  }

  render() {
    let { title, message, closeText, confirmText, onConfirm, onClose, id } = this.props;
    return (
      <Modal show={this.state.showModal} id={id}>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {message}
        </Modal.Body>

        <Modal.Footer>
          <Button style="primary" branded={true} onClick={onClose} data-action="cancel">{closeText ? closeText : 'Close'}</Button>
          <Button style="primary" branded={true} onClick={onConfirm} data-action="confirm">{confirmText ? confirmText : 'Save'}</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
